import {
  Table,
  TableContainer,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Text,
  Icon,
  Button,
  Input,
  InputGroup,
  InputLeftAddon,
  SimpleGrid,
  useDisclosure,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogBody,
  AlertDialogFooter,
  useColorModeValue,
} from "@chakra-ui/react";

import { useHistory } from "react-router-dom";
import React, { useMemo, useEffect, useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import AuthService from "services/auth.services.js";
import ApiService from "services/api.js";
import UtilService from "services/util.service.js";
// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenuExcelPopUp";
import Pagination from "components/dataDispaly/Pagination";
import HeaderPBData from "./HeaderPBData";

// Assets
import { MdCheckCircle, MdCancel, MdOutlineError } from "react-icons/md";
export default function PBData(props) {
  // custom variable

  let DateFrom = UtilService.dateFrom;
  let DateTo = UtilService.dateTo;

  const history = useHistory();

  // Use state variable
  const { columnsData } = props;
  const [data, setData] = useState([]);
  const [dataPage, setDataPage] = useState([]);
  const [dataPageSize, setDataPageSize] = useState(5);
  const [loading, setLoading] = useState(true);
  const [inputDateFrom, setDateFrom] = useState(DateFrom);
  const [inputDateTo, setDateTo] = useState(DateTo);
  const [inputDateFromBackdate, setDateFromBackdate] = useState(DateFrom);
  const [inputDateToBackdate, setDateToBackdate] = useState(DateTo);
  const [inputBill, setInputBill] = useState("");
  const [inputBranch, setInputBranch] = useState("");
  const [urlExcel, setUrlExcel] = useState("");

  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");

  const options = ApiService.optionsBranch();

  // use disclosure
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Ref variable
  const skipPageResetRef = React.useRef();
  const cancelRef = React.useRef();

  // memo variable
  const columns = useMemo(() => columnsData, [columnsData]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    initialState,
    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageCount: dataPage },
      manualPagination: true,
      pageCount: dataPage,
      autoResetPage: !skipPageResetRef.current,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  useEffect(() => {
    try {
      // console.log("testtasj39asf")
      const fetchData = async () => {
        const today = new Date(inputDateFrom);
        // Format today's date to YYYY-MM-DD
        const formattedToday = today.toISOString().split("T")[0];
        setMinDate(formattedToday);

        // Create a new date object for one month ahead
        const nextMonthDate = new Date(inputDateFrom);
        nextMonthDate.setMonth(today.getMonth() + 1);
        // Format the date one month ahead to YYYY-MM-DD
        const formattedNextMonthDate = nextMonthDate
          .toISOString()
          .split("T")[0];

        setMaxDate(formattedNextMonthDate);

        const rangeDateFromTo = (new Date(inputDateTo)-new Date(inputDateFrom))/86400000

        if(rangeDateFromTo > 31 || rangeDateFromTo < 0){
          const nextMonthDateFrom = new Date(inputDateFrom);
          nextMonthDateFrom.setDate(today.getDate()+1);
          // Format the date one month ahead to YYYY-MM-DD
          const formattedNextMonthDateTo = nextMonthDateFrom
            .toISOString()
            .split("T")[0];
          setDateTo(formattedNextMonthDateTo)
        }


        try {
          skipPageResetRef.current = true;
          // let response = await ApiService.client.get(
          //   `/GetAllDataPb1PaginationAndFiltering/${pageIndex + 1
          //   }/${dataPageSize}/${inputBranch === "" ? ApiService.firstBranch() : inputBranch
          //   }/${inputBill === "" ? "all" : inputBill
          //   }/${inputDateFrom}/${inputDateTo}`,
          //   await ApiService.options()
          // );
          const requestOptions = await ApiService.options();
          let response = await ApiService.client.get(
            "/pb1/GetAllDataPb1PaginationAndFiltering",
            {
              params: {
                page: pageIndex + 1,
                limit: dataPageSize,
                branch_ids:
                  inputBranch === ""
                    ? options?.map((data) => data.id).join(",")
                    : inputBranch,
                bill_id: inputBill === "" ? "" : inputBill,
                from_order_date: inputDateFrom,
                to_order_date: inputDateTo,
              },
              ...requestOptions,
            }
          );
          //},await ApiService.options());

          setDataPage(response.data["total_halaman"]);
          setPageSize(dataPageSize);
          setData(response.data.data);
          skipPageResetRef.current = false;
        } catch (error) {
          // if (error.response.status === 401) {
          //   // AuthService.logout().then(
          //   //   () => {
         //   //     console.log("Success Logout");
          //   //   },
          //   //   (error) => {
          //   //     const resMessage =
          //   //       (error.response &&
          //   //         error.response.data &&
          //   //         error.response.data.message) ||
          //   //       error.message ||
          //   //       error.toString();
          //   //   }
          //   // );
          //   // history.push("/auth/sign-in");
          // }
          if (error.response.status === 401) {
            AuthService.logout().then(() => {
              history.push("/auth/sign-in");
            });
          }
        }
      };
      //   setUrlExcel(ApiService.excel + `/backdatePb1Process/exportAllPb1`, {
      //         params: {
      //           page: pageIndex + 1,
      //           limit: dataPageSize,
      //           branch_ids: inputBranch === "" ? options?.map(data => data.id).join(',') : inputBranch,
      //           bill_id: inputBill === "" ? "" : inputBill,
      //           from_order_date: inputDateFrom,
      //           to_order_date: inputDateTo
      //         }
      // });
      let excelUrl =
        ApiService.excel +
        `/pb1/ExportPb1toExcel?` +
        `branch_ids=${
          inputBranch === ""
            ? options?.map((data) => data.id).join(",")
            : inputBranch
        }&` +
        `bill_id=${inputBill === "" ? "" : inputBill}&` +
        `from_order_date=${inputDateFrom}&` +
        `to_order_date=${inputDateTo}`;

      setUrlExcel(excelUrl);
      fetchData();
    } catch (error) {
      if (error.response.status === 401) {
        AuthService.logout().then(() => {
          history.push("/auth/sign-in");
        });
      }
    }
  }, [
    pageIndex,
    dataPage,
    dataPageSize,
    pageSize,
    inputDateFrom,
    inputDateTo,
    inputBill,
    inputBranch,
  ]);

  // function backdate
  const processBackdatePB1 = async () => {
    try {
      let response = await ApiService.client
        .get(
          `/backdatePb1Process/${inputDateFromBackdate}/${inputDateToBackdate}`,
          await ApiService.options()
        )
        .then((response) => {
          window.location.reload();
        });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  return (
    <Card
      direction={{ base: "column", sm: "row" }}
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      <Flex px="25px" justify="space-between" mb="20px" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          PB1 Data
        </Text>
        <Menu urlExcel={urlExcel} />
      </Flex>

      <HeaderPBData
        inputDateFrom={inputDateFrom}
        inputDateTo={inputDateTo}
        inputBill={inputBill}
        inputBranch={inputBranch}
        minDate={minDate}
        maxDate={maxDate}
        setDateFrom={setDateFrom}
        setDateTo={setDateTo}
        setBill={setInputBill}
        setInputBranch={setInputBranch}
        setMinDate={setMinDate}
        setMaxDate={setMaxDate}
      />

      <TableContainer>
        <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
          <Thead>
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th
                    //{...column.getHeaderProps(column.getSortByToggleProps())}
                    pe="10px"
                    key={index}
                    borderColor={borderColor}
                  >
                    <Flex
                      justify="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      {column.render("Header")}
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()} key={index}>
                  {row.cells.map((cell, index) => {
                    let data = "";
                    if (cell.column.Header === "ID") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "BRANCH ID") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "BILL ID") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "ORDER BEGIN") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "AMOUNT") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "CUSTOMER TYPE") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "DPP_PB1") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "PB1") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "DPP_PPN") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "PPN") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    }
                    return (
                      <Td
                        {...cell.getCellProps()}
                        key={index}
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "150px", md: "200px", lg: "auto" }}
                        borderColor="transparent"
                      >
                        {data}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableContainer>
      <Pagination
        canNextPage={canNextPage}
        nextPage={nextPage}
        canPreviousPage={canPreviousPage}
        previousPage={previousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        gotoPage={gotoPage}
        pageSize={pageSize}
        setDataPageSize={setDataPageSize}
        pageCount={pageCount}
      />
    </Card>
  );
}
